import { c as _c } from "react/compiler-runtime";
// One day, we will provide the ability to prompt the user to finish signup here
const AbandonedEventBody = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default AbandonedEventBody;